var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-content-header", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "top" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.itemid
                    ? _c("node-element-local-tasks", {
                        attrs: { itemid: _vm.itemid },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notpublished
                    ? _c("div", { staticClass: "messages warning" }, [
                        _vm._v("\n          Not published\n        "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-body" },
        _vm._l(_vm.slices, function (slice, index) {
          return _c(
            "div",
            { key: index, staticClass: "slice" },
            [
              _vm.sliceContained(slice.data)
                ? _c(
                    "b-container",
                    [
                      _c(
                        "b-row",
                        { staticClass: "justify-content-center" },
                        [
                          _c(
                            "b-col",
                            _vm._b(
                              {},
                              "b-col",
                              _vm.getSliceWidth(slice.data),
                              false
                            ),
                            [
                              _c(_vm.getSliceComponent(slice), {
                                tag: "component",
                                attrs: { slice: slice, pageid: _vm.itemid },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(_vm.getSliceComponent(slice), {
                    tag: "component",
                    attrs: { slice: slice, pageid: _vm.itemid },
                  }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "bottom" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }